export default "__VITE_ASSET__73cabbd1__"